import { apiInstance } from "@/api/instance";

export default async function (beautyId) {
  return apiInstance.get(`/beauty/${beautyId}`);
}
